export default __webpack_public_path__ + "static/media/programs.0ca8eb9c.jpg";